import { useContext, useState } from "react";
import "./NameForm.scss";
import { simplyClick, validateName } from "../../helpers";
import ButtonSubmit from "../ButtonSubmit";
import InputGlobal from "../InputGlobal";
import { errorEventsName } from "../../constants";
import { ContextProfileUser } from "../../lib/profileContext";
import Tooltip from "../Tooltip";

function NameForm({ nextStep }) {
  const [errorName, setErrorName] = useState(null);
  const { data, setData } = useContext(ContextProfileUser);
  const [showTooltip, setShowTooltip] = useState(false);

  const handlerSubmit = (e) => {
    e.preventDefault();

    const { status, error = { text: "", type: "" } } = validateName(
      data?.first_name ?? ""
    );

    if (error.type) {
      simplyClick(errorEventsName[error.type]);

    }

    if (!status) {
      setErrorName(error.text);
    } else {
      simplyClick("cl_lnd_lt2_name_next", { first_name: data?.first_name });
      nextStep();
    }
  };

  const handleAddName = (e) => {
    setErrorName(null);
    setShowTooltip(false);
    setData({ ...data, first_name: e.target.value });
  };

  return (
    <div className="name__form-wrapper">
      <div className="user__form-top">
        <h3>My name</h3>
      </div>
      <form className="form__name" onSubmit={handlerSubmit} autoComplete="off">
        <p className="name__text">
          Share your name or nickname. Change it later if you want.
        </p>
        <div className="input__name-wrap">
          <InputGlobal
            onChange={(e) => handleAddName(e)}
            value={data.first_name ?? ""}
            placeholder={"Enter your name or nickname"}
            className={`input__global input__name ${errorName ? "input__error" : ""}`}
            name={"name"}
            type={"text"}
            autoComplete={"name"}
            onFocus={() => {
              setShowTooltip(true);
              simplyClick("cl_lnd_lt2_name_type_name");
            }}
            onBlur={() => setShowTooltip(false)}
          />
          {errorName && <p className="errorName">{errorName}</p>}
          <Tooltip
            text="Your name must include at least 2 English letters. No numbers or special characters are allowed."
            showTooltip={showTooltip}
            className="name"
          />
        </div>

        <ButtonSubmit className={"button__global button__name"} text={"NEXT"} />
        <div className="progress__dots">
          <span className="active"></span>
          <span className="active"></span>
          <span className="active"></span>
          <span className="active"></span>
          <span></span>
          <span></span>
        </div>
      </form>
    </div>
  );
}

export default NameForm;
